import { render, staticRenderFns } from "./NewDatabaseConfiguration.vue?vue&type=template&id=58bc542a&"
import script from "./NewDatabaseConfiguration.vue?vue&type=script&lang=js&"
export * from "./NewDatabaseConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58bc542a')) {
      api.createRecord('58bc542a', component.options)
    } else {
      api.reload('58bc542a', component.options)
    }
    module.hot.accept("./NewDatabaseConfiguration.vue?vue&type=template&id=58bc542a&", function () {
      api.rerender('58bc542a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/configurationManager/NewDatabaseConfiguration.vue"
export default component.exports